export const SUBJECT_TEAM_PORTAL = 'team_portal';

export const ACTION_LOGIN = 'login';
